import mapboxgl from 'mapbox-gl';

// ------------------------------  Maps ------------------------------

var eventmap = document.getElementById("eventmap");
if (typeof (eventmap) != 'undefined' && eventmap != null) {

    var lng = eventmap.getAttribute("data-lng");
    var lat = eventmap.getAttribute("data-lat");

    var localmarkerpin = document.querySelector(".mapmarkerpin");

    mapboxgl.accessToken = 'pk.eyJ1IjoibWlsbGNvIiwiYSI6ImNrcjBzbmtpYzF1dmwycHFwajEzbHIxdGEifQ.hdV70L-T53bpdn6cbcsCLg';
    const map = new mapboxgl.Map({
        container: 'eventmap', // container ID
        style: 'mapbox://styles/millco/ckr0ss4qn282k17mxeuc4ev38', // style URL
        center: [lng, lat], // starting position [lng, lat] 
        zoom: 11.5 // starting zoom
    });

    var marker = new mapboxgl.Marker(localmarkerpin, {
            anchor: 'center',
        })
        .setLngLat([lng, lat])
        .addTo(map);

    const nav = new mapboxgl.NavigationControl();
    map.addControl(nav, 'bottom-left');
    map.scrollZoom.disable();
} else false;


var studiosmap = document.getElementById("studiosmap");
if (typeof (studiosmap) != 'undefined' && studiosmap != null) {

    var lng = studiosmap.getAttribute("data-lng");
    var lat = studiosmap.getAttribute("data-lat");


    mapboxgl.accessToken = 'pk.eyJ1IjoibWlsbGNvIiwiYSI6ImNrcjBzbmtpYzF1dmwycHFwajEzbHIxdGEifQ.hdV70L-T53bpdn6cbcsCLg';
    const buildingmap = new mapboxgl.Map({
        container: 'studiosmap', // container ID
        style: 'mapbox://styles/millco/ckr0ss4qn282k17mxeuc4ev38', // style URL
        center: [lng, lat], // starting position [lng, lat] 
        zoom: 15 // starting zoom
    });


    var g;
    var buildingsmarker = document.getElementsByClassName("buildings-map-marker");
    for (g = 0; g < buildingsmarker.length; g++) {

        var buildinglng = buildingsmarker[g].getAttribute("data-lng");
        var buildinglat = buildingsmarker[g].getAttribute("data-lat");

        var marker = new mapboxgl.Marker(buildingsmarker[g], {
                anchor: 'center',
            })
            .setLngLat([buildinglng, buildinglat])
            .addTo(buildingmap);
    };

    const nav = new mapboxgl.NavigationControl();
    buildingmap.addControl(nav, 'bottom-left');
    buildingmap.scrollZoom.disable();


} else false;